import de from '@translations/de/statusBadge.json';
import en from '@translations/en/statusBadge.json';
import pl from '@translations/pl/statusBadge.json';
import sl from '@translations/sl/statusBadge.json';
import uk from '@translations/uk/statusBadge.json';
import bg from '@translations/bg/statusBadge.json';
import cz from '@translations/cz/statusBadge.json';
import fr from '@translations/fr/statusBadge.json';
import gr from '@translations/gr/statusBadge.json';
import it from '@translations/it/statusBadge.json';
import pr from '@translations/pr/statusBadge.json';
import ru from '@translations/ru/statusBadge.json';
import sk from '@translations/sk/statusBadge.json';
import sp from '@translations/sp/statusBadge.json';
import tr from '@translations/tr/statusBadge.json';
import hu from '@translations/hu/statusBadge.json';
import { ITranslations } from '@/types/common';
import { StatusBadgeTransFields } from './types';

export const statusBadgeTranslations: ITranslations<StatusBadgeTransFields> = {
  name: 'statusBadge',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
